<template>
  <motlet :options="motletOptions">
    <template v-slot:content="{ props }">
      <bar-chart :settings="settings" :motlet="props.motlet" />
    </template>
  </motlet>
</template>

<script>
import barChartable from './barChartable';

export default {
  mixins: [barChartable],
  data() {
    return {
      motletOptions: {
        id: 'detailview/java/operatingSystem/Filesystem',
        title: 'FileSystem',
        monitor: {
          monitorCode: 'C_JAVA_OS_FSYS',
          points: 15,
          categoryField: 'fsysname',
          valueField: 'usedRate',
        },
        settings: { chart: { use: false } },
      },
    };
  },
  watch: {
    timestamp(value) {
      this.fetchData(value);
    },
  },
  // created() {
  //   // cpu monitorCode 의 mark-line timestamp 값을 취한다.
  //   bus.$on('change:timestamp-JAVA_OS_CPU', this.fetchData);
  // },
  // beforeDestroy() {
  //   bus.$off('change:timestamp-JAVA_OS_CPU');
  // },
};
</script>
